export function eur(n: number, d = 0): string {
  const f = Math.pow(10, d);
  return "€" + Number(Math.round(n * f) / f).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function pctFmt(v: number, d = 2): string {
  return Number(v).toFixed(d) + "%";
}

// Euro without misleading rounding: small amounts keep up to 4 decimals (trailing
// zeros trimmed, min 2), larger amounts use the standard 2-decimal format.
export function eurExact(n: number): string {
  if (Math.abs(n) >= 100) return eur(n, 2);
  let s = n.toFixed(4);
  s = s.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  const dot = s.indexOf(".");
  if (dot === -1) s += ".00";
  else if (s.length - dot - 1 < 2) s += "0".repeat(2 - (s.length - dot - 1));
  return "€" + s;
}

// Transaction counts can be fractional (monthly averages). Show up to one
// decimal so multiplications reconcile, with thousands separators.
export function txnsFmt(n: number): string {
  const r = Math.round(n * 10) / 10;
  return Number.isInteger(r)
    ? r.toLocaleString("en-US")
    : r.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

const MONTH_FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const MONTH_ABBR = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function parseYearMonth(ym: string): { year: number; month: number } | null {
  const match = /^(\d{4})-(\d{1,2})/.exec(ym || "");
  if (!match) return null;
  const month = parseInt(match[2], 10) - 1;
  if (month < 0 || month > 11) return null;
  return { year: parseInt(match[1], 10), month };
}

// "2026-01" -> "Jan"
export function monthShort(ym: string): string {
  const p = parseYearMonth(ym);
  return p ? MONTH_ABBR[p.month] : ym;
}

// "2026-01" -> "January 2026"
export function monthLong(ym: string): string {
  const p = parseYearMonth(ym);
  return p ? `${MONTH_FULL[p.month]} ${p.year}` : ym;
}

// "2026-06-13" -> "Jun 13, 2026"
export function shortDate(iso: string): string {
  const match = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(iso || "");
  if (!match) return iso;
  const month = parseInt(match[2], 10) - 1;
  if (month < 0 || month > 11) return iso;
  return `${MONTH_ABBR[month]} ${parseInt(match[3], 10)}, ${match[1]}`;
}
